import { Col, Container, Row } from '@slal/ui/layout';
import { Heading, P } from '@slal/ui/typography';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Div } from '../Layout';
import { ChevronIcon } from './ChevronIcon';
import {
    AccordionPanelBox,
    FooterBar,
    FooterLink,
    FooterLinkList,
    FooterLinkListItem,
    FooterLinks,
    FooterLinkWrapper,
    FooterWrapper,
    LinkGroup,
    Logo,
    SecondaryFooter,
    StyledCol,
    StyledHr,
    ToggleButton,
} from './styles';
export const Footer = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <FooterWrapper role="contentinfo">
            <FooterBar title="Footer Bar" />

            <Container>
                <Row>
                    <StyledCol col={12} md={6}>
                        <Logo role="presentation" variant="dark" />
                    </StyledCol>
                    <StyledCol col={12} md={6}>
                        <FooterLinkWrapper>
                            <LinkGroup aria-labelledby="help-and-support-link-group-title">
                                <Heading id="help-and-support-link-group-title" level={5}>
                                    Help and Support
                                </Heading>
                                <FooterLink
                                    to="https://www.standardlife.co.uk/contact-us"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Contact us
                                </FooterLink>
                            </LinkGroup>
                        </FooterLinkWrapper>
                    </StyledCol>
                </Row>

                <StyledHr />

                <FooterLinks>
                    <FooterLinkList>
                        <FooterLinkListItem>
                            <FooterLink
                                to="https://www.standardlife.co.uk/help/accessibility"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Accessibility
                            </FooterLink>
                        </FooterLinkListItem>
                        <FooterLinkListItem>
                            <FooterLink to="https://www.standardlife.co.uk/legal" target="_blank" rel="noreferrer">
                                Legal information
                            </FooterLink>
                        </FooterLinkListItem>
                        <FooterLinkListItem>
                            <FooterLink to="https://www.standardlife.co.uk/privacy" target="_blank" rel="noreferrer">
                                Privacy Policy
                            </FooterLink>
                        </FooterLinkListItem>
                        <FooterLinkListItem>
                            <FooterLink to="https://www.standardlife.co.uk/cookies" target="_blank" rel="noreferrer">
                                Cookie Policy
                            </FooterLink>
                        </FooterLinkListItem>
                    </FooterLinkList>
                </FooterLinks>
            </Container>

            <SecondaryFooter>
                <Container>
                    <Row>
                        <Col col={12}>
                            <Div>
                                <ToggleButton
                                    onClick={toggleAccordion}
                                    open={isOpen}
                                    aria-labelledby="website-and-provider-details-button-title"
                                >
                                    <ChevronIcon title="Chevron Icon" />
                                    <Heading level={6} id="website-and-provider-details-button-title">
                                        Website and provider details
                                    </Heading>
                                </ToggleButton>
                                {isOpen && (
                                    <AccordionPanelBox>
                                        <P>
                                            This website describes products and services provided by Phoenix Life
                                            Limited, trading as Standard Life.
                                        </P>

                                        <P>
                                            Phoenix Life Limited, trading as Standard Life, is registered in England and
                                            Wales (1016269) at 10 Brindleyplace, Birmingham, B1 2JB.
                                        </P>

                                        <P>
                                            Phoenix Life Limited is authorised by the Prudential Regulation Authority
                                            and regulated by the Financial Conduct Authority and the Prudential
                                            Regulation Authority.
                                        </P>

                                        <P>
                                            You can{' '}
                                            <Link
                                                to="https://www.standardlife.co.uk/legal#company-and-regulation-details"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                find out more information
                                            </Link>{' '}
                                            about the companies providing the products and services.
                                        </P>
                                    </AccordionPanelBox>
                                )}
                            </Div>
                        </Col>
                    </Row>
                </Container>
            </SecondaryFooter>
        </FooterWrapper>
    );
};
